/**
 * @public
 * @class TimeData
 */
export class TimeData {
    /** @public @property { string } year Year */
    year
    /** @public @property { string } month Month (0 padded) */
    month
    /** @public @property { string } day Day (0 padded) */
    day
    /** @argument { string } text A date format string of backend response */
    constructor(year, month, day) {
        this.year = year
        this.month = month
        this.day = day
    }
    toNumber() {
        return (+this.year * 100_00) + (+this.month * 100) + +this.day
    }
    toText() {
        return [this.year, this.month, this.day].join("-")
    }
    compare(to) {
        return this.toNumber() - to.toNumber()
    }
    static fromText(text) {
        return new TimeData(...(text ?? "1970-01-01").split("-"))
    }
    static fromNumber(num) {
        let [, year, month, day] = (num+"").match(/(\d{4})(\d\d)(\d\d)/)
        return new TimeData(year, month, day)
    }
}
